import React from "react";
import PropTypes from "prop-types";
import { noop } from "utils/common";

export default function SelectItem({ value: { id, selector, isSelected, isDisabled } }){
	return (
		<label htmlFor={id} className="checkbox-select-container select-cell">
			<input
				id={id}
				type="checkbox"
				checked = {isSelected}
				disabled={isDisabled}
				className="custom-checkbox"
				onChange = {(e) => {
					let { currentTarget: { checked } } = e;

					selector([id], checked);
				}}
			/>
			<span className="pretty-checkbox" />
		</label>
	);
}

SelectItem.displayName = "SelectItem";

SelectItem.propTypes = {
	value: PropTypes.shape({
		id: PropTypes.number,
		isSelected: PropTypes.bool,
		selector: PropTypes.func,
	}),
};

SelectItem.defaultProps = {
	value: {
		id: -1,
		isSelected: false,
		selector: noop,
	},
};
